import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-regular-svg-icons";
/** Inline success marker (check + label) shown on a completed action card. */
export function ActionDoneIndicator(_ref) {
  var label = _ref.label;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-shrink-0 items-center gap-1.5 text-sds-success-secondary"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCheck,
    className: "w-4 h-4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-strong"
  }, label !== null && label !== void 0 ? label : t("key.task_status.done", {
    defaultValue: "Done"
  })));
}